<template>
  <page-template type="norightpanel">
    <template v-slot:toolbar>
        <tool-bar @status-change="status = $event" type="operations-action-collaborative" title="Opérations" class="px-8"></tool-bar>
    </template>
    <template v-slot:main-panel-content>
      <div class="padding-x">
        <div class="d-flex rectangular-element-container">
          <rectangular-element
            v-for="operation in cachedOperations"
            :key="operation._id"
            :title="operation.title"
            :date="operation.updatedAt"
            :guide="getCatById(operation.category)"
            :actions="items"
            :id="operation._id"
            :publish-url="`${apiURL}/manage/operation/activated/${operation._id}`"
            :publish-object="operation"
            @update="updateOperations()"
            :class="operation.activated ? 'on-going' : 'to-publish'"
          ></rectangular-element>
          <rectangular-element-new title="Nouvelle opération" link="/operations/new"></rectangular-element-new>
        </div>
      </div>
    </template>
  </page-template>
</template>

<script>
  import pageTemplate from '@/templates/PageTemplate.vue'
  import toolBar from '@/components/ToolBar.vue'
  import rectangularElement from '@/components/RectangularElement.vue'
  import rectangularElementNew from '@/components/RectangularElementNew.vue'
  import axios from 'axios'
  import { apiURL } from '@/../config'
  export default {
    name: 'Operations',
    components: { pageTemplate, toolBar, rectangularElement, rectangularElementNew },
    data: () => {
      return {
        status: false,
        operations: [],
        operationCategories: [],
        apiURL
      }
    },
    async created () {
      try {
        this.$store.dispatch('loading')
        // ALL ON GOING OPERATIONS
        const operationRes = await axios.get(`${apiURL}/data/operation/all`)
        this.operations = operationRes.data.model
        // OPERATION CATEGORIES
        const operationCategoriesRes = await axios.get(`${apiURL}/data/operation/categories`)
        this.operationCategories = operationCategoriesRes.data.model
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      } finally {
        this.$store.dispatch('stop_loading')
      }
    },
    computed: {
      cachedOperations () {
        if (!this.operations.length) return []
        return this.operations.filter(o => {
          return o.done === this.status
        })
      },
      items () {
        return [
          { title: 'Editer', icon: 'mdi-square-edit-outline', callback: this.editCb },
          { title: 'Ouvrir', icon: 'mdi-eye-outline', callback: this.openCb },
          { title: 'Dupliquer', icon: 'mdi-checkbox-multiple-blank-outline', callback: this.duplicateCb },
          { title: 'Désactiver', icon: 'mdi-close', callback: this.deactivateCb },
          { title: 'Supprimer', icon: 'mdi-trash-can-outline', callback: this.deleteCb }
        ]
      }
    },
    methods: {
      getCatById (id) {
        const cats = this.operationCategories.filter(c => {
          return c._id === id
        })
        return cats.length ? cats[0].name : ''
      },
      async updateOperations () {
        try {
          this.$store.dispatch('loading')
          // ALL ON GOING OPERATIONS
          const operationRes = await axios.get(`${apiURL}/data/operation/all`)
          this.operations = operationRes.data.model
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      },
      // EDIT OPERATION
      editCb (id) {
        this.$router.push(`/operations/edit/${id}`)
      },
      // OPEN OPERATION
      openCb (id) {
        this.$router.push(`/operations/open/${id}`)
      },
      // DUPLICATE OPERATION
      async duplicateCb (id) {
        try {
          this.$store.dispatch('loading')
          await axios.post(`${apiURL}/manage/operation/duplicate/${id}`)
          await this.updateOperations()
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      },
      // DEACTIVATE OPERATION
      async deactivateCb (id) {
        try {
          this.$store.dispatch('loading')
          await axios.put(`${apiURL}/manage/operation/unactivated/${id}`)
          await this.updateOperations()
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      },
      // DELETE OPERATION
      async deleteCb (id) {
        try {
          this.$store.dispatch('loading')
          await axios.delete(`${apiURL}/manage/operation/${id}`)
          await this.updateOperations()
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      }
    }
  }
</script>
